import React, { useEffect, useState } from 'react'
import './style.scss';
import { setButtonClick, setErrorButton, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setIsShowButtonNot } from '../../store/buttonNotSlice';
import CustomTitle from '../../components/UI/title/CustomTitle';
import ProductivityContent from './ProductivityContent';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';


export default function Productivity() {
    const initialCheckboxState = [
        {
            id: '0',
            checked: false,
            text: "Generate more video ads",
            priority: 0,
        },
        {
            id: '1',
            checked: false,
            text: "Lower video ad production costs",
            priority: 3,
        }, {
            id: '2',
            checked: false,
            text: "Generate more static ads",
            priority: 1,
        }, {
            id: '3',
            checked: false,
            text: "Reduce static ad production costs",
            priority: 5,
        }, {
            id: '4',
            checked: false,
            text: "Launch more ad campaigns",
            priority: 2,
        }, {
            id: '5',
            checked: false,
            text: "Cut ad campaign expenses",
            priority: 6,
        }
    ];

    const [disabled, setDisabled] = useState(true);
    const [checkboxes, setCheckboxes] = useState(initialCheckboxState);
    const [error, setError] = useState(false);
    const [value, setValue] = useState('');

    const dispatch = useDispatch();
    const history = useHistory();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);


    const getPriorityCheckedCheckboxId = () => {
        const checkedCheckboxes = checkboxes.filter(checkbox => checkbox.checked);
        if (checkedCheckboxes.length > 0) {
            const checkboxWithHighestPriority = checkedCheckboxes.reduce((minPriorityCheckbox, currentCheckbox) => {
                return currentCheckbox.priority < minPriorityCheckbox.priority ? currentCheckbox : minPriorityCheckbox;
            });
            return checkboxWithHighestPriority.id;
        }
        return null;
    };

    useEffect(() => {
        setValue(checkboxes.filter(checkbox => checkbox.checked).map(checkbox => checkbox.id));
    }, [checkboxes]);
    const { trackP1Event } = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            if (disabled) {
                setError(true);
                dispatch(setErrorButton(true))
                dispatch(setButtonClick(false));
                setTimeout(() => {
                    setError(false);
                    dispatch(setErrorButton(false))
                }, 2000);
                return;
            }
            dispatch(setButtonClick(false));
            trackP1Event('onboarding_ad_goals', {
                goals: checkboxes.filter(checkbox => checkbox.checked).map(checkbox => checkbox.text).join(', ')
            })

            queryParams.set('productivity-goals', value);
            queryParams.set('productivity-goals-id', getPriorityCheckedCheckboxId());
            queryParams.set('goals-text',
                checkboxes.filter(checkbox => checkbox.checked).map(checkbox => checkbox.text).join(', ')
            );

            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch, disabled]);


    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Continue'));
        dispatch(setIconButton(''));

        dispatch(setIsShowButtonNot(false));
    }, []);


    return (
        <div className="productivity-goals page">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '24rem' }}
                        title={'What improvements would boost your productivity?'}
                    />
                    <div className="productivity-goals-wrapper">
                        <ProductivityContent checkboxes={checkboxes} setCheckboxes={setCheckboxes} error={error} setDisabled={setDisabled} setError={setError} setValue={setValue} />
                    </div>
                </div>
            </PageContent>

        </div>
    )
}
